import Stack from '@mui/material/Stack';
import CustomerSuspended from '../../../components/customerSuspended/CustomerSuspended';
import useAuthStore from '../../../datastore/useAuth';
import useSelectedSite from '../../../hooks/useSelectedSite';
import CustomerNavbar from '../components/CustomerNavbar';
import usePolling from '../../../hooks/usePolling';
import StoreReselectCoordinator from '../components/StoreReselectCoordinator';

export default function CustomerLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { updateEstimatedWaitTime } = useSelectedSite((state) => ({
    updateEstimatedWaitTime: state.updateEstimatedWaitTime,
  }));

  const { currentUser, isSuspended } = useAuthStore()
  const isCustomerSuspended = currentUser && isSuspended

  usePolling(updateEstimatedWaitTime, { initialInterval: 60000, maxInterval: 60000 });

  return (
    <Stack sx={{ flex: 1, height: '100vh' }}>
      <StoreReselectCoordinator />
      <CustomerNavbar />
      <Stack
        sx={{
          flexGrow: 1,
        }}
      >
        {
          isCustomerSuspended ? (
            <CustomerSuspended />
          ) : children
        }
      </Stack>
    </Stack>
  );
}
